class Lexicon
{
    constructor ()
    {
        this.navContainer = document.querySelector( '.keywords-menu' );
        this.navLinks     = this.navContainer.querySelectorAll( '.jump-letters .letter-jump-link.has-words' );

        this.keywordGroups = document.querySelectorAll( '.keywords-group' );

        this.setupTocHighlighting();
    }


    setupTocHighlighting ()
    {
        if ( typeof IntersectionObserver === 'function' )
        {
            this.tocObserver = new IntersectionObserver( entries =>
            {
                entries.forEach( entry =>
                {
                    const id = entry.target.getAttribute( 'id' );

                    if ( entry.intersectionRatio > 0 )
                    {
                        Array.from( this.navLinks )
                            .filter( el => el.getAttribute( 'href' ) === ('#' + id) )
                            .forEach( ( found, i ) =>
                            {

                                found.classList.add( 'current-section' );
                            } );
                    } else
                    {
                        Array.from( this.navLinks )
                            .filter( el => el.getAttribute( 'href' ) === ('#' + id) )
                            .forEach( ( found, i ) =>
                            {
                                found.classList.remove( 'current-section' );
                            } )
                    }
                } );
            } );

            // Track all sections that have an `id` applied
            this.keywordGroups.forEach( ( section ) =>
            {
                this.tocObserver.observe( section );
            } );
        }
    }

}

document.addEventListener( 'DOMContentLoaded', () =>
{
    if ( document.querySelector( 'body' ).classList.contains( 'lexicon-index' ) )
    {
        const lexicon = new Lexicon();
    }

} );
